// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate, successGenerate } from "../../common";
import api from '../../../services/api'
import { callbackProps, ID, ISchool, IClassroom, IClassroomCurriculum } from "../../../constants";

const actionCreateSchool = (
    payload: ISchool,
    callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.createSchool,
  callback,
});

const actionGetClassrooms = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_CLASSROOMS),
  api: api.getClassrooms,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

const actionUpdateStaff = (
    staffId: number,
    payload: any,
    callback?: (a: callbackProps) => void
): requestActionProps => ({
    type: requestGenerate(Types.REQUEST),
    api: (data: any) => api.updateStaff(staffId, data),
    payload: { 
        data: payload 
    },
    callback,
});

export {
  actionCreateSchool,
  actionGetClassrooms,
  actionUpdateStaff
};
